<template>
  <div class="body">
    <div class="title">
      活动资讯发布
      <!-- 面包屑导航区域 -->
      <div class="fansk">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/shouye' }"><span class="dsadf">
            首页
          </span></el-breadcrumb-item>
          <el-breadcrumb-item>发布管理</el-breadcrumb-item>
          <el-breadcrumb-item>活动资讯</el-breadcrumb-item>
          <el-breadcrumb-item>发布</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>

    <div style="margin: -20px 0 20px;"><el-button size="mini" @click="$router.back()">返回</el-button></div>

    <el-card>
      <el-form ref="form" :model="addQuery" :rules="rules" label-width="80px" :label-position="labelPosition">
        <el-form-item label="标题" prop="name" label-width="10%">
          <el-input v-model="addQuery.name"  style="width: 30%" placeholder="请输入活动资讯标题"></el-input>
        </el-form-item>
        <!-- <el-form-item label="地址" prop="area_id" label-width="10%">
          <el-cascader
            v-model='areaArray'
            :props="checkedData.typeOptions"
            @change="changList"
          ></el-cascader>
        </el-form-item> -->
        <!-- <el-form-item label="社团地址" prop="area_id" label-width="10%">
          <el-cascader v-model='areaArray' :props="checkedData.typeOptions" @change="changList"></el-cascader>
        </el-form-item>
        <el-form-item label="" prop="longitude" label-width="10%">
          <el-row style="margin-bottom: 10px">
            <vxe-button size="medium" content="获取社团位置" status="primary" @click="GetJWD"></vxe-button>
          </el-row>
          <el-row style="margin-bottom: 10px">
            <el-input disabled v-model="addQuery.address" style="width: 500px" placeholder="请输入详细地址" clearable></el-input>
          </el-row>
          <el-row style="margin-bottom: 10px">
            <el-input v-model="addQuery.longitude" style="width: 500px" placeholder="请选择经度" disabled></el-input>
          </el-row>
        <el-row>
            <el-input v-model="addQuery.latitude" style="width: 500px" placeholder="请选择纬度" disabled></el-input>
          </el-row>
        </el-form-item> -->



        <el-form-item label="封面" prop="cover" label-width="10%">
          <div class="imgbox" v-if="addQuery.cover">
            <img
              :src="addQuery.cover"
              alt=""
              class="imgs"
              @click="addQuery.cover = ''"
            />
            <img src="../../assets/img/shanchu.png" mode="" class="close"
                 @click="addQuery.cover = ''" alt="">
          </div>
          <el-upload
            v-else
            ref="upload"
            action="https://ydmxhapi.yundongm.cn:8099/service/admin/upload_pic"
            :on-success="handleSuccess"
            :limit="9"
            :before-upload="$beforeUploadImage"
            list-type="picture"
            :data="{ token: token }"
            name="pic"
          >
            <el-button size="small" type="primary">选择</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="正文内容" prop="content" label-width="10%">
          <quill-editor
            class="appwrapper"
            v-model="addQuery.content"
            :rows="3"
            ref="myQuillEditor"
            :options="editorOption"
            style="width: 50%">
          </quill-editor>
        </el-form-item>
      </el-form>
      <el-button  type="primary" size="medium" @click="fabu">发布</el-button>
    </el-card>

    <div class="block-none">
      <el-upload
        class="avatar-uploader1"
        ref="upload_1"
        :action="
          editorImgOrVideo === 'img'
            ? 'https://ydmxhapi.yundongm.cn:8099/service/admin/upload_pic'
            : 'https://ydmxhapi.yundongm.cn:8099/service/admin/uploadvideo'
        "
        :on-success="uploadSuccess"
        :limit="1"
        :before-upload="
          editorImgOrVideo === 'img'
            ? $beforeUploadImage
            : $beforeUploadVideo"
        list-type="picture"
        :data="{ token: token }"
        :name="editorImgOrVideo === 'img' ? 'pic' : 'video'"
        :shrow-file-list="false"
      >
        <el-button size="small" type="primary">点击上传</el-button>
      </el-upload>
    </div>
    <search-address ref="searchAddressRef" @onConfirm="AddrConfirm"></search-address>
  </div>
</template>

<script>
import { getWzArea } from "@/api/city";
import { addPolic } from '@/api/tiezi';

import { shangxiehuixiangqing } from "@/api/shangxiehui";

import SearchAddress from '../../components/Amap/SearchAddress.vue';

const toolbarOptions = [
  ["bold", "italic", "underline", "strike"], // toggled buttons
  ["blockquote", "code-block"],
  [{ header: 1 }, { header: 2 }], // custom button values
  [{ list: "ordered" }, { list: "bullet" }],
  [{ script: "sub" }, { script: "super" }], // superscript/subscript
  [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
  [{ align: [] }],
  ["link", "image", "video"],
  ["clean"], // remove formatting button
];

export default {
  name: 'zhengcejiedufabu',
  components: { SearchAddress },
  data () {
    return {
      form: {},
      labelPosition: 'left',
      token: sessionStorage.getItem('token'),
      areaArray: [],
      checkedData: {
        // sendData: ['province_name'], // 默认选中值
        typeOptions: {
          lazy: true, // 开启懒加载
          lazyLoad: this.lazyLoad,
        },
      },
      addQuery: {
        token: sessionStorage.getItem('token'),
        name: '',
        // province_id: "",
        // city_id: "",
        area_id: "",
        town_id: '',
        address: '',
        cover: '',
        content: '',
        longitude:"",
        latitude:"",
        address:"",
      },
      rules: {
        name: [{ required: true, message: '请输入', trigger: 'blur' }],
        area_id: [{ required: true, message: '请选择', trigger: 'blur' }],
        // address: [{ required: true, message: '请输入', trigger: 'blur' }],
        cover: [{ required: true, message: '请上传', trigger: 'blur' }],
        content: [{ required: true, message: '请输入', trigger: 'blur' }],
        reg_address: [{ required: true, message: '请输入', trigger: 'blur' }],
        address: [{ required: true, message: '请输入', trigger: 'blur' }],
      },
      // 富文本编辑器配置
      editorOption: {
        placeholder: "请输入内容",
        theme: "snow", // or 'bubble'
        modules: {
          toolbar: {
            container: toolbarOptions, // 工具栏
            handlers: {
              image: function (value) {
                if (value) {
                  this.editorImgOrVideo = "img";
                  // debugger;
                  // 触发input框选择图片文件
                  document.querySelector(".avatar-uploader1 input").click();
                } else {
                  this.quill.format("image", false);
                }
              },
              video: (value) => {
                if (value) {
                  this.editorImgOrVideo = "video";
                  // debugger;
                  // 触发input框选择视频文件
                  document.querySelector(".avatar-uploader1 input").click();
                } else {
                  this.quill.format("video", false);
                }
              },
            },
          },
        },
      },
      editorImgOrVideo: "img",
    }
  },
  async created() {
    await this.initSportTypes()
    await this.initSportSiteList();
    // this.getAreaList();
    if (this.$route.query.id) {
      this.postType = 1;
      const obj = {
        token: sessionStorage.getItem("token"),
        id: this.$route.query.id,
      };
      shangxiehuixiangqing(obj).then(({ data: res }) => {
        console.log("resss", res);
        this.$nextTick(() => {
          let areaArray = [res.area_id];
          this.areaArray = areaArray;
          const Query = {
              token: sessionStorage.getItem("token"),
              id: this.$route.query.id,
              types: 1,
              org_com: res.org_com,
              area_id: res.area_id,
              longitude: res.longitude,
              latitude: res.latitude,
              address: res.address,
          };
          this.addQuery = Query;
          console.log("_Query", Query)
          // 初始赋值活动类型复选框
          if (Query.sport_type) {
              console.log("_Query.sport_type", Query.sport_type)
              this.checkSportTypesList = Query.sport_type.split(",").map(item=>Math.floor(item));
          }
        });
      });
    } else {
        this.postType = 0;
    }
  },
  methods: {
    async getAreaList() {
      try {
        const res = await getWzArea();
        const result = res.data.data;
        result.forEach((item) => {
          item.value = item.code;
          item.label = item.name;
        });
          this.areaList = result;
      } catch (error) {
        console.log(error);
      }
    },
    async lazyLoad(node, resolve) {
      const level = node.level;
      let result;
      let res;
      let param;
      switch (level) {
        case 0: // 一级
          res = await getWzArea();
          result = res.data.data;
          result.forEach((item) => {
            item.value = item.code;
            item.label = item.name;
            item.leaf = item.code === "330300000000" || item.code === "100000000000";
          });
          break;
        case 1: // 二级
            param = {
              code: node.data.code,
              pid: node.data.id,
            };
             res = await getWzArea(param);
            result = res.data.data;
            result.unshift({
              value: '0',
              pcode: param.code,
              pid: param.pid,
              label: '全部',
              name: '全部',
              code: '0',
              leaf: false
            })
            result.forEach(item => {
              item.value = item.code;
              item.label = item.name;
              item.leaf = level >= 1;
            });
          break;
        default:
          result = [];
          break;
      }
      resolve(result);
    },
    changList(val) {
      console.log("_changeList", val)
      this.addQuery.area_id = val[0];
      this.addQuery.town_id = val[1] || '';
    },
    GetJWD() {
      this.$refs.searchAddressRef.init({ type:'address', address: this.addQuery.address, lng: this.addQuery.longitude, lat: this.addQuery.latitude })
    },
    AddrConfirm(res) {
      console.log("onAddrConfirm", res);
      this.showMap = false;
      this.addQuery = {
        ...this.addQuery,
        address: res.address,
        longitude: res.lng,
        latitude: res.lat
      }
    },
    handleSuccess(response, file, fileList) {
      if (response.result === 1) {
        this.$message({
          message: response.msg,
          type: "success",
          duration: "2000",
        });
        this.addQuery.cover = response.pic_url;
      }
    },
    uploadSuccess(res, file) {
      this.$refs.upload_1.clearFiles()
      // res为图片服务器返回的数据
      // 获取富文本组件实例
      let quill = this.$refs.myQuillEditor.quill;
      // 如果上传成功
      if (res.result === 1) {
        // 获取光标所在位置
        let length = quill.getSelection().index;
        // 插入图片  res.info为服务器返回的图片地址
        if (this.editorImgOrVideo === "img") {
          quill.insertEmbed(length, "image", res.pic_url);
          // 调整光标到最后
          quill.setSelection(length + 1);
        } else {
          quill.insertEmbed(length, "video", res.video_url);
          // 调整光标到最后
          quill.setSelection(length + 1);
        }

        this.$forceUpdate();
      } else {
        this.$message.error("图片插入失败");
      }
    },
    fabu () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          // console.log("_this.addQuery", this.addQuery)
          const addQuery = this.addQuery;
          if(addQuery.town_id && addQuery.town_id !== '0') {  //  选择二级并且未选中全部
            // delete addQuery.area_id
          }
          if(addQuery.town_id === '0' || !addQuery.town_id) { // 选择二级选择全部, 传递一级code; 没有值
            delete addQuery.town_id
          }
          console.log("_addQuery", addQuery)

          addPolic(addQuery).then(({ data: res }) => {
            console.log('ress', res)
            if (res.result === -1) {
              this.$message({
                message: res.msg,
                type: 'error',
                duration: '2000'
              })
              setTimeout(() => {
                window.sessionStorage.clear()
                this.$router.push('/login')
              }, 1000)
            }
            if (res.result === 0) {
              this.$message({
                message: res.msg,
                type: 'error',
                duration: '2000'
              })
              return false
            }
            if (res.result === 1) {
              this.$message({
                message: res.msg,
                type: 'success',
                duration: '2000'
              })
              this.addQuery = {}
              this.$router.push('/zhengcejiedu')
            }
          })
        } else {}
      });
    }
  }
}
</script>

<style scoped lang="less">
.btn{
  width: 107px;
  height: 36px;
  opacity: 1;
  background: linear-gradient(135deg,#3d9aff, #3380f2);
  border-radius: 2px;
  font-size: 16px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: left;
  color: #ffffff;
  letter-spacing: 0px;
  border: none;
}
.body {
  display: flex;
  flex-direction: column;
  .title {
    opacity: 1;
    font-size: 30px;
    font-family: PingFang SC, PingFang SC-Heavy;
    font-weight: 800;
    text-align: left;
    color: #2e2e2e;
    letter-spacing: 0px;
    margin-bottom: 35px;
    display:flex;
    flex-direction: row;
    align-items: center;
    .fansk{
      margin-top: 30px;
      margin-left: 32px;
    }
    .dsadf{
      color: #3D9AFF;
    }
  }
}
.imgbox {
  width: 288px;
  //height: 88px;
  opacity: 1;
  background: rgba(0, 0, 0, 0);
  border-radius: 5px;
  position: relative;
  .imgs {
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
  .imgs:hover {
    opacity: 0.8;
  }
  .close {
    position: absolute;
    right: 10px;
    top: 10px;
    width: 20px;
    height: 20px;
    opacity: 1;
    z-index: 999;
    background: #e54848;
    border-radius: 50%;
  }
}
.block-none {
  display: none;
}
</style>
